"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvidenceContext = void 0;
const react_1 = require("react");
exports.EvidenceContext = (0, react_1.createContext)(undefined);
//# sourceMappingURL=evidence-context.js.map